import { WechatProfitSharingPlatformEnum, WechatProfitSharingRelationTypeEnum, WechatProfitSharingTypeEnum } from '@lighthouse/core'

export const PROFIT_SHARING_TYPE_OPTIONS = [
    {
        label: '商户',
        value: WechatProfitSharingTypeEnum.MERCHANT_ID
    },
    {
        label: '个人',
        value: WechatProfitSharingTypeEnum.PERSONAL_OPENID
    }
]

export const PROFIT_SHARING_PLATFORM_OPTIONS = [
    {
        label: '微信公众号 OPENID',
        value: WechatProfitSharingPlatformEnum.WECHAT
    },
    {
        label: '小程序 OPENID',
        value: WechatProfitSharingPlatformEnum.MINI_PROGRAM
    }
]

export const PROFIT_SHARING_RELATION_TYPE_OPTIONS = [
    {
        label: '门店',
        value: WechatProfitSharingRelationTypeEnum.STORE
    },
    {
        label: '员工',
        value: WechatProfitSharingRelationTypeEnum.STAFF
    },
    {
        label: '店主',
        value: WechatProfitSharingRelationTypeEnum.STORE_OWNER
    },
    {
        label: '合作伙伴',
        value: WechatProfitSharingRelationTypeEnum.PARTNER
    },
    {
        label: '总部',
        value: WechatProfitSharingRelationTypeEnum.HEADQUARTER
    },
    {
        label: '品牌方',
        value: WechatProfitSharingRelationTypeEnum.BRAND
    },
    {
        label: '分销商',
        value: WechatProfitSharingRelationTypeEnum.DISTRIBUTOR
    },
    {
        label: '用户',
        value: WechatProfitSharingRelationTypeEnum.USER
    },
    {
        label: '供应商',
        value: WechatProfitSharingRelationTypeEnum.SUPPLIER
    },
    {
        label: '自定义',
        value: WechatProfitSharingRelationTypeEnum.CUSTOM
    }
]
